var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { utils, ContextualMenuClient, Input, icons } from "zebulon-controls";
// import { Input } from "./Input";
import { computeMetaPositions } from "./utils/compute.meta";
import { cellData } from "./utils/compute.data";
import { getRowErrors } from "./utils/utils";
import classnames from "classnames";

var filter = function filter(column, position, height, width, filterTo, onChange, openFilter, focusedId, component) {
  var className = classnames({
    "zebulon-table-cell": true,
    "zebulon-table-header": true,
    "zebulon-table-filter": true,
    "zebulon-table-filter-checkbox": column.dataType === "boolean",
    "zebulon-table-filter-checkbox-undefined": (column.v === undefined || column.v === null) && column.dataType === "boolean"
  });
  var textAlign = column.alignement || "left";
  if (!column.alignement) {
    if (column.dataType === "number") textAlign = "right";else if (column.dataType === "date" || column.dataType === "boolean") textAlign = "center";
  }
  var focused = (focusedId || document.activeElement || {}.id) === String(column.index_ + 1000 * filterTo);
  var id = "filter" + (filterTo ? "To" : "") + ": " + component + "--" + column.index_;
  var value = column.v,
      div = void 0;
  if (column.filterType === "values" && column.v) {
    // value = "Y";
    div = React.createElement(
      "div",
      {
        style: {
          height: height,
          width: width
        },
        id: id,
        key: id,
        className: className,
        onClick: function onClick(e) {
          return openFilter(e, column);
        }
      },
      React.createElement("div", {
        style: {
          background: icons.filter,
          backgroundSize: "cover",
          height: "1em",
          width: "1em",
          marginTop: "0.1em",
          marginRight: "0.1em"
        }
      })
    );
  } else {
    if (filterTo) {
      value = column.vTo;
    } else if (column.filterType === "values") {
      value = "";
    }
    div = React.createElement(Input, {
      column: column,
      id: id,
      key: id,
      className: className,
      style: {
        // position: "absolute",
        height: height,
        width: width,
        textAlign: textAlign
      },
      editable: true,
      focused: focused,
      inputType: "filter",
      tabIndex: column.index_ * 2 + (filterTo || 0) + 100,
      value: value,
      filterTo: filterTo,
      onChange: onChange,
      onFocus: function onFocus(e) {
        // console.log("filter", this);
        openFilter(e, column);
      }
    });
  }

  return div;
};
var header = function header(column, position, height, width, handleClick, handleDragStart, handleDragOver, handleDrop, component
// handleDragEnd
) {
  var sort = "";
  if (column.sort === "asc") {
    sort = "↑";
  } else if (column.sort === "desc") {
    sort = "↓";
  }
  var id = "header: " + component + "--" + column.index_;
  return React.createElement(
    ContextualMenuClient,
    {
      key: id,
      id: id,
      className: "zebulon-table-cell zebulon-table-header",
      onClick: function onClick() {
        return handleClick(column, false);
      },
      onDoubleClick: function onDoubleClick() {
        return handleClick(column, true);
      },
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      style: {
        height: height,
        width: width,
        justifyContent: "space-between",
        display: "flex",
        paddingRight: "unset"
      },
      column: column,
      menu: "column-header-menu",
      component: component
    },
    React.createElement(
      "div",
      {
        id: id,
        key: 0,
        style: { width: width - 15 },
        draggable: true,
        onDragStart: function onDragStart(e) {
          return handleDragStart(e, "move");
        }
      },
      column.caption || column.id
    ),
    React.createElement(
      "div",
      { id: id, key: 1, style: { width: 8 } },
      sort
    ),
    React.createElement("div", {
      id: id,
      key: 2,
      style: {
        width: 6,
        cursor: "col-resize",
        opacity: 0
      },
      draggable: true,
      onDragStart: function onDragStart(e) {
        return handleDragStart(e, "resize");
      }
    })
  );
};
var auditCell = function auditCell(row, column, status, data, params, style, component) {
  var _cellData = cellData(row, column, status, data, params, false),
      value = _cellData.value;

  var textAlign = column.alignement || "left";
  if (!column.alignement) {
    if (column.dataType === "number") {
      textAlign = "right";
    } else if (column.dataType === "date" || column.dataType === "boolean") {
      textAlign = "center";
    }
  }
  style.textAlign = textAlign;
  var className = classnames({
    "zebulon-table-cell": true,
    "zebulon-table-cell-audit": true,
    "zebulon-table-cell-odd": true
    // "zebulon-table-cell-selected": selected,
    // "zebulon-table-cell-focused": focused,
    // "zebulon-table-cell-editable": editable && focused
  });
  // if (column.dataType === "boolean") value = value || false;
  var id = "audit-cell: " + component + "-" + row.index_ + "-" + column.index_;
  return React.createElement(Input, {
    row: row,
    column: column,
    style: style,
    className: className,
    value: value,
    key: id,
    id: id
  });
};
var filterEmpty = function filterEmpty(id, position, width, height) {
  return React.createElement("div", {
    key: id + "-filter-empty",
    className: "zebulon-table-cell zebulon-table-header zebulon-table-filter-empty",
    style: {
      height: height,
      width: width
      // ,
      // border: "0.02em solid rgba(0, 0, 0, 0.2) ",
      // borderRight
    }
  });
};

// ↑↓
export var Headers = function (_Component) {
  _inherits(Headers, _Component);

  function Headers() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Headers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Headers.__proto__ || Object.getPrototypeOf(Headers)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (column, double) {
      if (!_this.props.isActive && _this.props.onActivation) {
        _this.props.onActivation();
      }
      var onSort = _this.props.onSort;

      if (!double) {
        _this.timer = setTimeout(function () {
          if (!_this.prevent) {
            onSort(column, false);
          }
          _this.prevent = false;
        }, 200);
      } else {
        clearTimeout(_this.timer);
        _this.prevent = true;
        onSort(column, true);
      }
    }, _this.getColumnIndex = function (id) {
      var ids = id.split("-");
      return ids[ids.length - 1];
    }, _this.handleDragStart = function (e, type) {
      _this.dragId = e.target.id;
      _this.dragType = type;
      _this.dragX = e.pageX;
      // console.log("handleDragStart", this.dragId, e);
      e.dataTransfer.setData("text", _this.dragId);
      e.stopPropagation();
    }, _this.handleDragOver = function (e) {
      // console.log("handleDragOver", e);
      if (_this.dragType === "move" || _this.dragType === "resize" && _this.props.meta.properties[_this.getColumnIndex(_this.dragId)].computedWidth + e.pageX - _this.dragX > 20) {
        e.preventDefault();
      }
    }, _this.handleDrop = function (e) {
      e.preventDefault();
      var meta = _this.props.meta.properties;
      if (_this.dragType) {
        if (_this.dragType === "move" && !utils.isNullOrUndefined(_this.dragId) && _this.dragId !== e.target.id) {
          meta[_this.getColumnIndex(_this.dragId)].index_ = meta[_this.getColumnIndex(e.target.id)].index_ + 0.1;
          meta.sort(function (a, b) {
            return a.index_ - b.index_;
          });
          computeMetaPositions(_this.props.meta);
          _this.props.onMetaChange();
        } else if (_this.dragType === "resize" && !utils.isNullOrUndefined(_this.dragX) && !utils.isNullOrUndefined(e.pageX)) {
          var column = meta[_this.getColumnIndex(_this.dragId)];
          var zoom = column.computedWidth / column.width;
          column.computedWidth += e.pageX - _this.dragX;
          column.width = column.computedWidth / zoom;
          computeMetaPositions(_this.props.meta);
          _this.props.onMetaChange();
        }
      }
      _this.dragId = null;
      _this.dragType = null;
      _this.dragX = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Headers, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.props.changingFilter;
    }
  }, {
    key: "render",
    value: function render() {
      var _props$scroll = this.props.scroll,
          shift = _props$scroll.shift,
          index = _props$scroll.startIndex;
      var _props = this.props,
          meta = _props.meta,
          width = _props.width,
          height = _props.height,
          onChange = _props.onChange,
          openFilter = _props.openFilter,
          focusedId = _props.focusedId,
          headersLength = _props.headersLength,
          locked = _props.locked,
          auditedRow = _props.auditedRow,
          auditStatus = _props.auditStatus,
          component = _props.component,
          data = _props.data,
          params = _props.params;

      var cells = [];
      var position = 0,
          first = true;
      if (!locked) {
        index = Math.max(index, utils.isNullOrUndefined(meta.lockedIndex) ? 0 : meta.lockedIndex + 1);
      } else {
        index = 0;
        shift = 0;
      }
      while (index < meta.properties.length && position < width) {
        var column = meta.properties[index];
        var columnWidth = Math.max(Math.min(first ? column.computedWidth + shift : column.computedWidth, width - position), 0);
        var div = null;
        if (!column.hidden && columnWidth) {
          first = false;
          div = header(column, position, height / headersLength, columnWidth, this.handleClick, this.handleDragStart, this.handleDragOver, this.handleDrop, component);
          if (headersLength > 1) {
            if (auditedRow) {
              div = [div];
              var _style = {
                // position: "absolute",
                // left: position,
                width: columnWidth,
                // top: height / 2,
                height: height / 2
              };
              div.push(auditCell(auditedRow, column, auditStatus, data, params, _style, component));
            } else {
              div = [div];
              if (!["object", "array", "function", "text"].includes(utils.nullValue(column.dataType, "object"))) {
                div.push(filter(column, position, height / headersLength, columnWidth, false, onChange, openFilter, focusedId, component));
              } else {
                div.push(filterEmpty(column.id, position, columnWidth, height / headersLength));
              }
              if (headersLength === 3) {
                if (column.filterType === "between" && !["object", "array", "function", "text"].includes(utils.nullValue(column.dataType, "object"))) {
                  div.push(filter(column, position, height / headersLength, columnWidth, column.filterType === "between", onChange, openFilter, focusedId, component));
                } else {
                  div.push(filterEmpty(column.id + "-to", position, columnWidth, height / headersLength));
                }
              }
            }
            div = React.createElement(
              "div",
              {
                key: column.id || "undefined " + column.index_,
                style: { display: "block", width: columnWidth, height: height }
              },
              div
            );
          }
          cells.push(div);
          position += columnWidth;
        }
        index += 1;
      }
      var style = {
        width: width,
        height: height,
        // overflow: "hidden",
        display: "flex"
      };
      if (!locked) {
        style.overflow = "hidden";
      }

      if (cells.length) {
        return React.createElement(
          "div",
          {
            id: "tutut",
            key: -2 - locked
            // id={type + filterTo ? "To" : ""}
            , style: Object.assign({}, this.props.style, style)
          },
          cells
        );
      } else {
        return null;
      }
    }
  }]);

  return Headers;
}(Component);
export var statusCell = function statusCell(style, className, index, row, status, _onClick, onDoubleClick, handleErrors, component, checkable, _onChange, isAudit, draggable, handleDragStart) {
  var glyph = void 0;
  if (status.deleted_) {
    glyph = "X";
  } else if (status.new_) {
    glyph = "+";
  } else if (status.updated_) {
    glyph = "√";
  } else {
    glyph = null;
  }
  var errors = getRowErrors(status, status.index_);
  if (errors.length && !status.deleted_) {
    style.color = "red";
  }
  if (checkable) {
    glyph = React.createElement("input", {
      type: "checkbox",
      checked: status.checked_ || false,
      onChange: function onChange() {
        return _onChange(row.index_);
      }
      // style={{ height: 20 }}
    });
  }
  var id = "status: " + component + "-" + (isAudit ? index : row.index_) + "-";
  return React.createElement(
    ContextualMenuClient,
    {
      id: id,
      key: id,
      className: className,
      style: style,
      onClick: function onClick(e) {
        return _onClick(index, e.shiftKey);
      },
      onMouseOver: function onMouseOver(e) {
        return handleErrors(e, errors);
      },
      onMouseOut: function onMouseOut(e) {
        return handleErrors(e, []);
      },
      onDoubleClick: onDoubleClick ? function (e) {
        return onDoubleClick(e, row);
      } : function () {},
      draggable: draggable,
      onDragStart: handleDragStart,
      status: status,
      row: row,
      menu: "row-header-menu",
      component: component
    },
    glyph
  );
};
export var Status = function (_Component2) {
  _inherits(Status, _Component2);

  function Status(props) {
    _classCallCheck(this, Status);

    var _this2 = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));

    _this2.onClick = function (index, extension) {
      var _this2$props = _this2.props,
          meta = _this2$props.meta,
          scroll = _this2$props.scroll;

      var columns = (meta.visibleIndexes || [0])[0];
      var startRowIndex = extension ? _this2.props.selectedIndex : index;
      _this2.props.selectRange({
        end: { rows: index, columns: columns },
        start: { rows: startRowIndex, columns: meta.properties.length - 1 }
      }, undefined, undefined, undefined, undefined, index === scroll.startIndex || index === _this2.stopIndex);
    };

    _this2.onChange = function (index) {
      if (_this2.props.checkable) {
        var updatedRows = _this2.state.updatedRows;
        if (!updatedRows[index]) {
          updatedRows[index] = { errors: {} };
        }
        updatedRows[index].checked_ = !updatedRows[index].checked_;
        if (_this2.props.checkable === 2) {
          updatedRows[index + 1 - 2 * (index % 2)].checked_ = !updatedRows[index].checked_;
        }
        _this2.setState({ updatedRows: updatedRows });
      }
    };

    _this2.handleDragStart = function (e) {
      e.stopPropagation();
      e.dataTransfer.setData("text", "status: " + e.target.id);
    };

    _this2.state = { updatedRows: _this2.props.updatedRows };
    return _this2;
  }

  _createClass(Status, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.updatedRows !== nextProps.updatedRows) {
        this.setState({ updatedRows: nextProps.updatedRows });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.status.loadingPage && !nextProps.noUpdate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          height = _props2.height,
          rowHeight = _props2.rowHeight,
          data = _props2.data,
          scroll = _props2.scroll,
          selectedIndex = _props2.selectedIndex,
          handleErrors = _props2.handleErrors,
          dataLength = _props2.dataLength,
          component = _props2.component,
          checkable = _props2.checkable,
          onDoubleClick = _props2.onDoubleClick,
          isAudit = _props2.isAudit,
          draggable = _props2.draggable;

      var updatedRows = this.state.updatedRows;
      var index = 0,
          indexPage = 0,
          rows = data;
      if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" && data.page) {
        rows = data.page;
        indexPage = data.pageStartIndex;
      }
      var cells = [];
      while (index < Math.min(dataLength || data.length, Math.ceil(height / rowHeight))) {
        var style = {
          // position: "relative",
          top: index === 0 ? 0 : scroll.shift + index * rowHeight,
          width: rowHeight,
          height: index === 0 ? rowHeight + scroll.shift : Math.min(rowHeight, height - (scroll.shift + index * rowHeight))
        };
        if (index + scroll.startIndex - indexPage < rows.length) {
          (function () {
            var row = rows[index + scroll.startIndex - indexPage];
            var updatedRow = updatedRows[row.index_] || { errors: {} };
            var className = classnames({
              "zebulon-table-status": true,
              "zebulon-table-status-selected": selectedIndex === index + scroll.startIndex
            });
            var ix = index;
            cells.push(statusCell(style, className, ix + scroll.startIndex, row, updatedRow, _this3.onClick, onDoubleClick, function (e, errors) {
              return handleErrors(e, ix, errors);
            }, component, checkable, _this3.onChange, isAudit, draggable));
          })();
        }
        index += 1;
      }
      this.stopIndex = index + scroll.startIndex - 1;
      return React.createElement(
        "div",
        {
          key: "status: " + component,
          id: "status: " + component,
          style: {
            width: rowHeight,
            height: height,
            // overflow: "hidden",
            position: "relative",
            diplay: "flex"
          }
        },
        cells
      );
    }
  }]);

  return Status;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/TableHeaders.js
// module id = 343
// module chunks = 0